import UntitledIcon from '@payaca/untitled-icons';
import { forwardRef, useState } from 'react';
import RawInput, { RawInputProps } from './RawInput';

export type PasswordInputProps = Omit<RawInputProps, 'type' | 'iconAfter'>;

const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ ...rest }, ref) => {
    const [visible, setVisible] = useState(false);

    return (
      <div className="relative">
        <RawInput {...rest} ref={ref} type={visible ? 'text' : 'password'} />

        <button
          type="button"
          onClick={() => setVisible((vis) => !vis)}
          className="absolute top-1/2 right-2 -translate-y-1/2 cursor-pointer bg-transparent flex items-center justify-center"
        >
          <UntitledIcon name={visible ? 'eye.3' : 'eye-off.3'} />
        </button>
      </div>
    );
  }
);

PasswordInput.displayName = 'PasswordInput';

export default PasswordInput;
